import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import ProtocolTable from "./ProtocolTable";
import ProtocolDeleteModal from "./ProtocolDeleteModal";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const ProtocolPage = () => {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const { permissionSet } = useSelector((state: RootState) => state.user);
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {hasPermission(Permission.ProtocolView, permissionSet ?? []) ? (
        <div className={`layout__contentPage__${theme}`}>
          <ProtocolTable />
          <ProtocolDeleteModal />
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
};

export default ProtocolPage;
